import { SCHEDULING_CONFLICTS_ABORT } from '../constants';
import config from '../config';

class ChooseApplicantCtrl {
  constructor(
    Authentication,
    ChooseService,
    ConfirmService,
    EventCollection,
    Utils,
    ShiftUtils,
    AccountService,
    AlertService,
    extendShiftModel,
    $uibModalInstance,
    shift,
    isDeny
  ) {
    'ngInject';

    Object.assign(this, {
      Authentication,
      ChooseService,
      ConfirmService,
      EventCollection,
      Utils,
      ShiftUtils,
      AccountService,
      AlertService,
      extendShiftModel,
      $uibModalInstance,
      shift,
      isDeny,
    });
    this.init();
  }

  async init() {
    this.applications = this.Utils.sortBy(this.shift.applications, 'id');
    this.selectedApplicationIds = [];

    await this.ShiftUtils.loadAsync();
    await this.EventCollection.getEvents(
      this.shift.dtstart,
      this.Utils.addDays(this.shift.dtend, 1)
    );
    this.userUnavailable = this.applications.map(
      (application) => !this.ShiftUtils.isUserAvailable(application.user, this.shift)
    );
  }

  openPremiumGuardModal(id) {
    if (this.isCheckboxDisabled(id)) {
      this.AccountService.openPremiumGuardModal('multipleApplicants');
    }
  }

  isCheckboxDisabled(applicationId) {
    return (
      !this.shift.user &&
      !this.Authentication.user.org.isPremium &&
      this.selectedApplicationIds.length &&
      !this.selectedApplicationIds.includes(applicationId)
    );
  }

  _handleError(error) {
    if (error && error !== SCHEDULING_CONFLICTS_ABORT) {
      this.error = this.Utils.getErrorMessages(error);
    }
  }

  get remainingSlots() {
    return this.shift.slots - this.selectedApplicationIds.length;
  }

  get selectedAll() {
    return this.selectedApplicationIds.length === this.applications.length;
  }

  get selectedApplicationId() {
    return this.selectedApplicationIds[0];
  }

  set selectedApplicationId(value) {
    this.selectedApplicationIds = [value];
  }

  set selectedAll(value) {
    if (value) {
      this.selectedApplicationIds = this.applications.map((a) => a.id);
    } else {
      this.selectedApplicationIds = [];
    }
  }

  async approve() {
    if (!this.selectedApplicationIds.length) {
      throw 'no applications selected';
    }

    const applicationIds = this.selectedApplicationIds;
    if (applicationIds.length > 1 && !this.Authentication.user.org.isPremium) {
      throw 'approve many disabled';
    }

    try {
      await this.ShiftUtils.approveApplications(this.shift, applicationIds, {
        ignoreGlobalErrorHandler: true,
      });
      this.$uibModalInstance.close('applicant_chosen');
    } catch (e) {
      this._handleError(e);
      throw e; // for progress-button
    }
  }

  async deny() {
    if (!this.selectedApplicationIds.length) {
      throw 'no applications selected';
    }

    const applicationIds = this.selectedApplicationIds;
    if (applicationIds.length > 1 && !this.Authentication.user.org.isPremium) {
      throw 'approve many disabled';
    }

    try {
      await this.EventCollection.denyShiftApplicants(this.shift.id, applicationIds, {
        ignoreGlobalErrorHandler: true,
      });
      this.$uibModalInstance.close({ applicants: applicationIds.length });
    } catch (e) {
      this._handleError(e);
      throw e; // for progress-button
    }
  }

  async applyForShift() {
    try {
      let checkRestBreakConflicts = false;
      if (config.CLOPENING_CONFLICT_ENABLED) {
        checkRestBreakConflicts = true;
      }

      const shift = await this.ShiftUtils.performConflictingRequest({
        request: (ignoreConflicts) =>
          this.EventCollection.applyForShift(
            this.shift.id,
            { ignoreConflicts, checkRestBreakConflicts },
            { ignoreGlobalErrorHandler: true }
          ),
      });

      Object.assign(this.shift, this.extendShiftModel(shift));
      this.init();
    } catch (e) {
      this._handleError(e);
    }
  }

  async cancelOffer() {
    try {
      await this.ShiftUtils.cancelShiftAvailability(this.shift);
      this.$uibModalInstance.close(false);
    } catch (e) {
      this._handleError(e);
    }
  }
}

export default ChooseApplicantCtrl;
